// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__11kvc","label":"LabeledBox_label__1a7Mo"};